import axios from "axios";
const baseUrl = "/AutoConnectSSO/api/Captcha/FirendlyCaptcha";

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function getCaptcha() {
  const response = await instance.get("");
  return response.data;
}

export const PSFriendlyCaptchaService = {
  getCaptcha
};
